module.exports = __webpack_public_path__ + "img/phone.ca461eb7.png";